import paramsToString from './paramsToString';

export default (config, link) => {
  const {
    FIREBASE_DOMAIN_URI_PREFIX,
    ANDROID_PACKAGE_NAME,
    IOS_BUNDLE_ID,
    IOS_APP_STORE_ID
  } = config;

  const params = {
    link,
    apn: ANDROID_PACKAGE_NAME,
    ibi: IOS_BUNDLE_ID,
    isi: IOS_APP_STORE_ID,
    efr: 1
  };

  return `${FIREBASE_DOMAIN_URI_PREFIX}${paramsToString(params)}`;
};
